export const USERS_IMAGE_BASE_URL: string = 'https://s3.eu-central-1.amazonaws.com/totems3/users/';
export const ORGANIZATIONS_IMAGE_BASE_URL: string = 'https://s3.eu-central-1.amazonaws.com/totems3/logos/';
